<template>
  <b-modal ref="ground-general-modal-ref" hide-footer title="General">
    <div class="" v-if="infoCards.length">
      <b-card
        v-for="(info, index) in infoCards"
        :key="index"
        class="general-info"
        :title="info.title"
      >
        <span v-if="info.sqlCodes">
          <div
            v-for="msgBlock in info.sqlCodes"
            :key="msgBlock.code"
            class="message"
          >
            <h5 v-show="msgBlock.title">
              {{ msgBlock.title }}
            </h5>
            <div v-html="msgBlock.content" />
          </div>
        </span>
        <span
          v-else-if="info.title.toUpperCase().includes('DRIVING INSTRUCTIONS')"
        >
          <div v-if="drivingInstructionsHTML" v-html="drivingInstructionsHTML" />
        </span>
      </b-card>
      <ServiceErrorMessage :error-loading-data="errorLoadingData" />
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small
            >This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { loadSQLData, getDrivingInstructions } from "./services";
import ServiceErrorMessage from "@/partials/service-error-message";
export default {
  components: { ServiceErrorMessage },
  data() {
    return {
      infoCards: [],
      payload: {},
      errorLoadingData: false,
      drivingInstructionsHTML: "",
    };
  },
  computed: {
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },
  methods: {
    async showModal(dataArr) {
      this.infoCards = [];
      // Show loading spinner on top of the modal
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      // Loop over data array
      for (const item of dataArr) {
        // Loop over message codes and get data from SQL
        if (item.sqlCodes) {
          for (const codeObj of item.sqlCodes) {
            let result = await loadSQLData({
              codes: [codeObj.code],
              meet_and_greet: item.meet_and_greet,
            });
            if (result.error === true) {
              this.errorLoadingData = true;
              break;
            }
            if (result.data && result.data.length) {
              codeObj.content = result.data
                .map(function (_data) {
                  return _data.message;
                })
                .join(" ");
            }
          }
          this.infoCards.push(item);
        } else if (
          item.title.toUpperCase().includes("DRIVING INSTRUCTIONS") &&
          item.href
        ) {
          this.infoCards.push(item);
          await this.fetchDrivingInstructions(item.href);
        }
      }
      // Close spinner
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });
      this.$refs["ground-general-modal-ref"].show();
    },
    closeModal() {
      this.$refs["ground-general-modal-ref"].hide();
    },
    async fetchDrivingInstructions(url) {
      const instructions = await getDrivingInstructions(url);
      this.drivingInstructionsHTML = instructions;
    },
  },
};
</script>
<style lang="scss">
@import "./style.scss";
</style>
